import React, { useEffect, useRef } from "react";
import { Fragment, useState } from "react";
import { Disclosure } from "@headlessui/react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  ArrowUpCircleIcon,
  ArrowsRightLeftIcon,
  Bars3CenterLeftIcon,
  CurrencyDollarIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  ChatBubbleLeftEllipsisIcon,
  ChatBubbleLeftRightIcon,
  EnvelopeIcon,
  EnvelopeOpenIcon,
  MegaphoneIcon,
  RadioIcon,
  TicketIcon,
  UserGroupIcon,
  UsersIcon,
  XMarkIcon,
  ChartBarSquareIcon,
  ChevronDownIcon,
  PresentationChartBarIcon,
  AcademicCapIcon,
  RectangleStackIcon
} from "@heroicons/react/24/outline";
import Avatar from "react-avatar-edit";
import { CheckIcon } from "@heroicons/react/20/solid";
import * as qs from "qs";
import "./Operations.css";

import {
  CloudArrowDownIcon,
  DocumentPlusIcon,
  ShoppingBagIcon,
  ListBulletIcon,
  DocumentTextIcon,
  IdentificationIcon,
  CreditCardIcon,
  PaperAirplaneIcon,
  UserPlusIcon,
  PencilIcon,
} from "@heroicons/react/24/outline";
import axios from "axios";
import { useParams, Link, Routes, Route, useNavigate, NavLink } from "react-router-dom";
import moment from "moment";
import Tag from "../Tag/Tag";
import { useFormik } from "formik";
import IdCardAll from "../All ID Card/IdCardAll";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Done from "../Alerts/Done";

import CustomCertificate from "../Certificate/CustomCertificate";

import RoomSh from "../Roomsharingreq/RoomSh";
import SelfCheckinHotel from "../Self Checkin Hotel Access/SelfCheckinHotel";
import Invitationevent from "../InvitationEvent/Invitationevent";
import NameChngReq from "../NameChange/NameChngReq";
import Registration from "../Registration/Registration";
import CulturePrfo from "../CulturePrfomis/CulturePrfo";
import RoomAllocation from "../Roomallocation/RoomAllocation";
import Ambassdor from "../Ambassdor";
import Ticket from "../Ticketops/Ticket";
import Registrationstatus from "../IsRegistration/Registrationstatus";
import NonAccCheckin from "../NonAccCheckIn/NonAccCheckin";
import AssignBag from "../AssignBag/AssignBag";
import { useDispatch } from "react-redux";
import { login, reset } from "../../features/auth/authSlice";
import { Toaster, toast } from "sonner";
import ConferenceFeedBack from "../ConferenceFeedback/ConferenceFeedBack";
import EmailSend from "../EmailSend/EmailSend";
import CreateEventa from "../Create New Event/CreateEventa";
import RegistrationdNavBar from "../Registration/RegistrationdNavBar";
import CheckInAllTypeRegistration from "../CheckInAlltypeRegistration/CheckInAllTypeRegistration";
import Chat from "../Chat/Chat";
import Announcement from "../Announcement Center/Announcement";
import DiplomaticExperts from "../Diplomatic Experts/DiplomaticExperts";
import Upgrades from "../Upgrades/Upgrades";
import CheckinNavbar from "../CheckInAlltypeRegistration/CheckinNavbar";
import AwardCertificate from "../Certificate/AwardCertificate";
import RepresentativeNavbar from "../Country Rep/RepresentativeNavbar";
import DiplomaticExpertsNavbar from "../Diplomatic Experts/DiplomaticExpertsNavbar";
import { ApplyForEvents } from "../Apply For Event/ApplyForEvents";
import PricingBreakDown from "../Pricing BreakDown/PricingBreakDown";
import LeadsProfile from "../Country Rep/Leads/LeadsProfile";
import SendInvitationEvent from "../Send Invitation Event/SendInvitationEvent";
import HotelRooms from "../Self Checkin Hotel Access/Hotel Room/HotelRooms";
import BagAllocationSelfCheckin from "../Self Checkin Hotel Access/Bag Allocation Self Checkin/BagAllocationSelfCheckin";
import AwardCertificateForImpactDirector from "../Certificate/AwardCertificateForImpactDirector";
import CoustomCertificateForimpactDirector from "../Certificate/CoustomCertificateForimpactDirector";
import AllIDCardForImpactDirector from "../All ID Card/AllIDCardForImpactDirector";
import AwardCertificateForGuest from "../Certificate/AwardCertificateForGuest";
import ParticipantionCertificateForImpact from "../Certificate/ParticipantionCertificateForImpact";
import EventItinerary from "../Event Itinerary/EventItinerary";
import EventItineraryNavBar from "../Event Itinerary/EventItineraryNavBar";
import AddNewItinerary from "../Event Itinerary/AddNewItinerary";
import EventItineraryDetails from "../Event Itinerary/EventItineraryDetails";
import ExtraNightStays from "../Extra Night Stays/ExtraNightStays";
import AuditLog from "../Audit Log/AuditLog";
import AuditLogDetail from "../Audit Log/AuditLogDetailPlaceholder";
import AnalyticsDashboard from "../Country Rep/CR Analytics/CRAnalyticsDashboard";
import ScholarshipApplications from "../Scholarship Applications/ScholarshipApplications";
import ScholarshipApplicationDetail from "../Scholarship Applications/ScholarshipApplicationDetail";
import ScholarshipTasks from "../Scholarship Tasks/ScholarshipTasks";
import ScholarshipTaskDetails from "../Scholarship Tasks/ScholarshipTaskDetail";
import CrPayment from "../Cr Payment/CrPayment";
// import { FeedbackIcons } from "../Small Components/FeedbackIcons";
import TransferRequestDetailPage from "../Transfer Requests/TransferRequestDetailPage";

const OperationsDashboard = () => {
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  // Configrations
  var userEmail;
  var JSToken;
  var accessToken;
  if (localStorage.user) {
    userEmail = localStorage.user_email;
    JSToken = JSON.parse(localStorage.user);
    accessToken = JSToken.access_token;
  }
  const config = {
    headers: { Authorization: `Bearer ${accessToken}` },
  };
  const nevigate = useNavigate();
  const dispatch = useDispatch();
  async function reFreshToken() {
    var rTokenParse = JSON.parse(localStorage.user);
    var rToken = rTokenParse.refresh_token;
    try {
      const response = await axios.post(
        "https://dash.bestdiplomats.org/api/method/frappe.integrations.oauth2.get_token",
        qs.stringify({
          grant_type: "refresh_token",
          refresh_token: rToken,
          client_id: window.$ClientID,
          scope: "all openid",
        })
      );
      // console.log("Refresh>>", response);

      if (response.status === 200) {
        var timeIn = Date.now();
        var userAfterRefresh = response.data;
        var fetchIdTokenBeforeParse = localStorage.user;
        var fetchIdTokenAfterParse = JSON.parse(fetchIdTokenBeforeParse);
        var fetchIdToken = fetchIdTokenAfterParse.id_token;
        userAfterRefresh.id_token = fetchIdToken;
        localStorage.setItem("user", JSON.stringify(userAfterRefresh));
        localStorage.setItem("date", timeIn);
        // dispatch(login(JSON.stringify(userAfterRefresh)));
      } else {
        localStorage.removeItem("user");
        localStorage.removeItem("date");
        dispatch(reset());
        nevigate("/logincomp");
      }
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    // -------- Access Token Expiry Check Start ------
    if (localStorage.user) {
      var dateInInt = parseInt(localStorage.date);
      var dateInIntWithExpiry = dateInInt + 3600000;
      var timeNow = Date.now();
      if (timeNow < dateInIntWithExpiry) {
        dispatch(login(localStorage.user));
      } else {
        reFreshToken();
      }
      // -------- Access Token Expiry Check End ------
    }
  }, []);

  // States

  const [onSendInvite, setOnSendInvite] = useState(false);
  const [onGenIDCard, setOnGenIDCard] = useState(false);
  const [onGenIDCardForImpactDirector, setOnGenIDCardForImpactDirector] = useState(false);
  const [onGenCertificate, setOnGenCertificate] = useState(false);
  const [onGenCoustomCertificateForimpact, setOnGenCoustomCertificateForimpact] = useState(false);
  const [onGenCoustomCertificateForimpactForDelegate, setOnGenCoustomCertificateForimpactForDelegate] = useState(false);
  const [onGenAwarCertificate, setOnGenAwarCertificate] = useState(false);
  const [onGenimpactDirectorAwarCertificate, setOnForimpactDirectorGenAwarCertificate] = useState(false);
  const [onGenimpactDirectorAwarCertificateForGuest, setOnForimpactDirectorGenAwarCertificateForGuest] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);

  const [isFormSubmmited, setIsFormSubmmited] = useState(false);
  const [isFormSubmmitedCertificate, setIsFormSubmmitedCertificate] =
    useState(false);
     const [isFormSubmmitedCertificateForImpact, setIsFormSubmmitedCertificateForImpact] =
    useState(false);
     const [isFormSubmmitedCertificateForImpactForDelegate, setIsFormSubmmitedCertificateForImpactForDelegate] =
    useState(false);
  const [isFormSubmmitedAwardCertificate, setIsFormSubmmitedAwardCertificate] =
    useState(false);
     const [isFormSubmmitedimpactDirectorAwardCertificate, setIsFormSubmmitedimpactDirectorAwardCertificate] =
    useState(false); 
    const [isFormSubmmitedimpactDirectorAwardCertificateForguest, setIsFormSubmmitedimpactDirectorAwardCertificateForguest] =
    useState(false);
  const [detailPersonReg, setDetailPersonReg] = useState(null);
  const [idCardFormData, setIdCardFormData] = useState(null);
  const [awardCertificateFormData, setAwardCertificateFormData] =
    useState(null); 
    const [awardCertificateFormDataForImpact, setAwardCertificateFormDataForImpact] =
    useState(null); 
    const [awardCertificateFormDataForImpactForGuest, setAwardCertificateFormDataForImpactForGuest] =
    useState(null);
  const [certificateFormData, setCertificateFormData] = useState(null);
  const [coustomcertificateFormDataImpactForDelegate, setCoustomCertificateFormDataImpactForDelegate] = useState(null);
  const [coustomcertificateFormDataImpact, setCoustomCertificateFormDataImpact] = useState(null);
  const [eventResponse, setEventResponse] = useState(null);
  const [eventResponseFull, setEventResponseFull] = useState(null);
  const { eventID } = useParams();
  const [apiFilters, setApiFilters] = useState(`["event","=","${eventID}"]`);

  const [openDraw, setOpenDraw] = useState(false);
  const cancelButtonRef = useRef(null);
  const [popUPImage, setPopUPImage] = useState(false);
  const [nameRequestUpdate, setNameRequestUpdate] = useState(false);
  const navigation = [
    {
      name: "Registrations",
      href: `registration-navbar/${eventID}/all-registrations/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Registration Requests",
      href: `apply-for-event`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Check In",
      href: `checkInAllTypeRegistration-event/${eventID}/all-checkin/${eventID}`,
      icon: UserGroupIcon,
      current: false,
    }, 
     {
      name: "Extra Night Stays",
      href: `extra-night-stay/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Audit Log",
      href: `audit-log/${eventID}`,
      icon: ChartBarSquareIcon,
      current: false,
    },
    {
      name: "Support Ticket ",
      href: `ticket-details/${eventID}`,
      icon: TicketIcon,
      current: false,
    },
    {
      name: "Transfer Request",
      href: `transfer-request`,
      icon: ArrowsRightLeftIcon,
      current: false,
    },
    {
      name: "Event Itinerary",
      href: `event-itinerary/${eventID}`,
      icon: DocumentPlusIcon,
      current: false,
    },
    {
      name: "Event Invitations",
      href: `invitation-event/${eventID}`,
      icon: EnvelopeOpenIcon,
      current: false,
    },
    {
      name: "Pricing BreakDown",
      href: `pri-breakdown/${eventID}`,
      icon: CurrencyDollarIcon,
      current: false,
    },
    // { name: 'Send Invitataion Events', href: `send-invitataion-events/${eventID}`, icon: CurrencyDollarIcon, current: false },
    // { name: 'Room Allocation', href: `roomallocation/${eventID}`, icon: ListBulletIcon, current: false },
    {
      name: "Non-Accommodation Checkin",
      href: `non-acc-checkin/${eventID}`,
      icon: UsersIcon,
      current: false,
    },
    {
      name: "Assign Bag",
      href: `assign-bag/${eventID}`,
      icon: ShoppingBagIcon,
      current: false,
    },
    {
      name: "Culture Performance",
      href: `culture-prfomis/${eventID}`,
      icon: RadioIcon,
      current: false,
    },
    // { name: 'Amabassador Profile Management', href: `ambassador-ops`, icon: ListBulletIcon, current: false },
    {
      name: "Moderators",
      href: `diplomatic-nav/${eventID}/diplomatic-experts/${eventID}`,
      icon: Bars3CenterLeftIcon,
      current: false,
    },
    {
      name: "Representative",
      href: `country-rep/${eventID}/representative/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Country Representatives Analytics",
      href: `country-rep/statistics`,
      icon: PresentationChartBarIcon,
      current: false,
    },
    {
      name: "Leads",
      href: `leads_profile/${eventID}`,
      icon: ChartBarIcon,
      current: false,
    },
    {
      name: "Conference Feedback",
      href: `conference-feedback/${eventID}`,
      icon: ChatBubbleLeftEllipsisIcon,
      current: false,
    },
    {
      name: "Name Changing Requests",
      href: `name-change-request/${eventID}`,
      icon: PencilIcon,
      current: false,
    },
    {
      name: "Events",
      href: `create-events/${eventID}`,
      icon: CalendarDaysIcon,
      current: false,
    },
    {
      name: "Send Email",
      href: `email-send/${eventID}`,
      icon: EnvelopeIcon,
      current: false,
    },
    {
      name: "Chat",
      href: `chat-request/${eventID}`,
      icon: ChatBubbleLeftRightIcon,
      current: false,
    },
    {
      name: "Upgrades",
      href: `upgrades-center/${eventID}`,
      icon: ArrowUpCircleIcon,
      current: false,
    },
    {
      name: "Announcement Center",
      href: `announcement-center/${eventID}`,
      icon: MegaphoneIcon,
      current: false,
    },
    {
      name: "Scholarship Applications",
      href: `scholarship-applications`,
      icon: AcademicCapIcon,
      current: false,
    },
     {
      name: "Scholarship Tasks",
      href: `scholarship-tasks`,
      icon: RectangleStackIcon,
      current: false,
    },
     {
      name: "Cr Payment",
      href: `cr-payment`,
      icon: RectangleStackIcon,
      current: false,
    },
  ];
  const OperationTeam = [
    {
      name: "Registrations",
      href: `registration-navbar/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Support Ticket ",
      href: `ticket-details/${eventID}`,
      icon: TicketIcon,
      current: false,
    },
    {
      name: "Transfer Request",
      href: `transfer-request`,
      icon: ArrowsRightLeftIcon,
      current: false,
    },
    {
      name: "Event Invitations",
      href: `invitation-event/${eventID}`,
      icon: EnvelopeOpenIcon,
      current: false,
    },
  ];
  const HotelMember = [
    {
      name: "Registrations",
      href: `registration-navbar/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
  ];
  const SelfCheckin = [
    {
      name: "Self Checkin Hotel Access",
      href: `self-checkin-hotel-access/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Hotel Rooms",
      href: `hotel-rooms/${eventID}`,
      icon: ListBulletIcon,
      current: false,
    },
  ];
  const BagAllocation = [
    {
      name: "Assign Bag",
      href: `assign-bag-for-checkin/${eventID}`,
      icon: ShoppingBagIcon,
      current: true,
    },
  ];

  const DelegatesManager = [
    {
      name: "Registrations",
      href: `registration-navbar/${eventID}`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Check In",
      href: `checkInAllTypeRegistration-event/${eventID}`,
      icon: UserGroupIcon,
      current: false,
    },
  ];
  const DirectorAmbassador = [
    {
      name: "Representative",
      href: `country-rep/631ee8473e/representative/631ee8473e`,
      icon: ListBulletIcon,
      current: true,
    },
    {
      name: "Amabassador Profile Management",
      href: `ambassador-ops`,
      icon: ListBulletIcon,
      current: false,
    },
    {
      name: "Leads",
      href: `leads_profile/${eventID}`,
      icon: ChartBarIcon,
      current: false,
    },
  ];
  const ChatManager = [
    {
      name: "Chat",
      href: `chat-request/${eventID}`,
      icon: ChatBubbleLeftRightIcon,
      current: true,
    },
  ];
  const CommunicationManager = [
    {
      name: "Chat",
      href: `chat-request/${eventID}`,
      icon: ChatBubbleLeftRightIcon,
      current: true,
    },
    {
      name: "Announcement Center",
      href: `announcement-center/${eventID}`,
      icon: MegaphoneIcon,
      current: false,
    },
  ];
  const SupportTeam = [
    {
      name: "Support Ticket ",
      href: `ticket-details/${eventID}`,
      icon: TicketIcon,
      current: true,
    },
    {
      name: "Chat",
      href: `chat-request/${eventID}`,
      icon: ChatBubbleLeftRightIcon,
      current: false,
    },
  ];
  const [
    currentNavigationDirectorAmbassador,
    setCurrentNavigationDirectorAmbassador,
  ] = useState(DirectorAmbassador);
  const [
    currentNavigationDelegatesManager,
    setCurrentNavigationDelegatesManager,
  ] = useState(DelegatesManager);
  const [currentNavigationChatManager, setCurrentNavigationChatManager] =
    useState(ChatManager);
  const [
    currentNavigationCommunicationManager,
    setCurrentNavigationCommunicationManager,
  ] = useState(CommunicationManager);
  const [currentNavigation, setCurrentNavigation] = useState(navigation);
  const [
    currentNavigationOperationHotelMember,
    setCurrentNavigationOperationHotelMember,
  ] = useState(HotelMember);
  const [SelfCheckinHotelAccess, setSelfCheckinHotelAccess] =
    useState(SelfCheckin);
  const [bagAllocation, setBagAllocation] = useState(BagAllocation);
  const [currentNavigationOperationTeam, setCurrentNavigationOperationTeam] =
    useState(OperationTeam);
  const [currentNavigationSupportTeam, setCurrentNavigationSupportTeam] =
    useState(SupportTeam);

  const handleClickNavigation = (index, setCurrentNavigation) => {
    const updatedNavigation = currentNavigation.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigation(updatedNavigation);
  };

  useEffect(() => {
    if (localStorage.role !== "Support Team") {
      const path = window.location.pathname.split("/")[3];

      const updatedNavigation = currentNavigation.map((item) => {
        const hrefSegments = item.href.split("/");
        if (hrefSegments?.includes(path)) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      });
      const hasCurrentItem = updatedNavigation.some((item) => item.current);
      if (!hasCurrentItem) {
        updatedNavigation[0].current = true;
      }

      setCurrentNavigation(updatedNavigation);
    }
  }, []);
  useEffect(() => {
    if (localStorage.role === "Director Ambassador") {
      const path = window.location.pathname.split("/")[3];
      // console.log(path);
      const updatedNavigation = currentNavigationDirectorAmbassador.map(
        (item) => {
          const hrefSegments = item.href.split("/");
          if (hrefSegments?.includes(path)) {
            return { ...item, current: true };
          } else {
            return { ...item, current: false };
          }
        }
      );
      const hasCurrentItem = updatedNavigation.some((item) => item.current);
      if (!hasCurrentItem) {
        updatedNavigation[0].current = true;
      }

      setCurrentNavigationDirectorAmbassador(updatedNavigation);
    }
  }, []);
  // const handleClickNavigation = (index) => {
  //   const updatedNavigation = currentNavigation.map((item, i) => {
  //     if (i === index) {
  //       return { ...item, current: true };
  //     } else {
  //       return { ...item, current: false };
  //     }
  //   });
  //   setCurrentNavigation(updatedNavigation);
  // };

  const handleClickNavigationteam = (index) => {
    const updatedNavigation = currentNavigationOperationTeam.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigationOperationTeam(updatedNavigation);
  };

  const handleClickNavigationSelfCheckin = (index) => {
    const updatedNavigation = SelfCheckinHotelAccess.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setSelfCheckinHotelAccess(updatedNavigation);
  };
  const handleClickBagAllocation = (index) => {
    const updatedNavigation = bagAllocation.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setBagAllocation(updatedNavigation);
  };
  const handleClickNavigationHotelMember = (index) => {
    const updatedNavigation = currentNavigationOperationHotelMember.map(
      (item, i) => {
        if (i === index) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      }
    );
    setCurrentNavigationOperationHotelMember(updatedNavigation);
  };
  const handleClickNavigationChatManager = (index) => {
    const updatedNavigation = currentNavigationChatManager.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigationChatManager(updatedNavigation);
  };
  const handleClickNavigationCommunicationManager = (index) => {
    const updatedNavigation = currentNavigationCommunicationManager.map(
      (item, i) => {
        if (i === index) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      }
    );
    setCurrentNavigationCommunicationManager(updatedNavigation);
  };
  const handleClickNavigationSupportTeam = (index) => {
    const updatedNavigation = currentNavigationSupportTeam.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigationSupportTeam(updatedNavigation);
  };
  const handleClickNavigationDelegatesManager = (index) => {
    const updatedNavigation = currentNavigationDelegatesManager.map(
      (item, i) => {
        if (i === index) {
          return { ...item, current: true };
        } else {
          return { ...item, current: false };
        }
      }
    );
    setCurrentNavigationDelegatesManager(updatedNavigation);
  };
  const handleClickDirectorAmbassador = (index) => {
    const updatedNavigation = DirectorAmbassador?.map((item, i) => {
      if (i === index) {
        return { ...item, current: true };
      } else {
        return { ...item, current: false };
      }
    });
    setCurrentNavigationDirectorAmbassador(updatedNavigation);
  };

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const result = await axios
          .get("https://dash.bestdiplomats.org/api/resource/Events/" + eventID)
          .then(async (response) => {
            setEventResponse(response.data.data.title);
            setEventResponseFull(response.data.data);
            // console.log(response.data.data);
            var isYes = 0;
            await response.data.data.access_role.forEach((element) => {
              if (element.role == localStorage.role) {
                isYes = isYes + 1;
              }
            });
            if (
              localStorage.role === "Director Ambassador" ||
              localStorage.role === "Self Checkin Hotel Access" ||
              localStorage.role === "Bag Allocation"
            ) {
            } else if (isYes != 1) {
              nevigate("/");
            }
          });
      } catch (e) {
        console.log(e);
      }
    };
    fetchEventData();
  }, []);

  // File Downloader
  const generatePdfDocument = async (documentData) => {
    const blob = await pdf(documentData).toBlob();
    saveAs(blob, "custom-ID-Card");
  };
  const handleChangeIfImage = () => {
    setPopUPImage(true);
  };
  // Formik Configration for ID Card Genertation

  const generateIdCard = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      first_line: "",
      second_line: "",
      event_name: eventResponse,
      qr_text: "https://bestdiplomats.org",
      color: "Blue",
    },
    onSubmit: async (values, { resetForm, handleChange }) => {
      setIdCardFormData(values);
      setIsFormSubmmited(true);
      toast.success("Id Card Generated Successfully");

      // generatePdfDocument(finalDocument);
    },
    enableReinitialize: true,
  });

  // Formik Configration for Award Certificate Genertation

  const generateAwardCertificate = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      type: "",
      event_title: eventResponseFull?.title,
      end_date: eventResponseFull?.end_date,
      country: eventResponseFull?.country,
      qr_text: "https://bestdiplomats.org",
    },
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setAwardCertificateFormData(values);
      setIsFormSubmmitedAwardCertificate(true);
      toast.success("Certificate Generated Successfully");

      resetForm(); // Reset the form fields to initial values
    },
    enableReinitialize: true,
  }); 
   // Formik Configration for Award impact Director Certificate Genertation

  const generateAwardCertificateimpactDirector = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      type: "OF AWARD",
      title: "",
      event_title: eventResponseFull?.title,
      end_date: eventResponseFull?.end_date,
      event_id: eventResponseFull?.name,
      country: eventResponseFull?.title,
      qr_text: "https://impactdirectors.org",
    },
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setAwardCertificateFormDataForImpact(values);
      setIsFormSubmmitedimpactDirectorAwardCertificate(true);
      toast.success("Certificate Generated Successfully");

      resetForm(); // Reset the form fields to initial values
    },
    enableReinitialize: true,
  }); 
     // Formik Configration for Speker and guest impact Director Certificate Genertation
  const generateAwardCertificateimpactDirectorForGuest = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      type: "OF THANKS",
      title: "",
      event_title: eventResponseFull?.title,
      end_date: eventResponseFull?.end_date,
      event_id: eventResponseFull?.name,
      country: eventResponseFull?.title,
      qr_text: "https://impactdirectors.org",
    },
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setAwardCertificateFormDataForImpactForGuest(values);
      setIsFormSubmmitedimpactDirectorAwardCertificateForguest(true);
      toast.success("Certificate Generated Successfully");

      resetForm(); // Reset the form fields to initial values
    },
    enableReinitialize: true,
  });

  // Formik Configration for Certificate Genertation

  const CoustomCertificategenerateCertificate = useFormik({
    
    initialValues: {
      first_name: "",
      last_name: "",
      first_line: "",
      second_line: "",
      type: "",
      event_title: eventResponseFull?.title,
      event_id: eventResponseFull?.name,
      end_date: eventResponseFull?.end_date,
      country: eventResponseFull?.title,
      qr_text: "https://impactdirectors.org",
    },
    
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setCoustomCertificateFormDataImpact(values);
      setIsFormSubmmitedCertificateForImpact(true);
      toast.success("Certificate Generated Successfully");
      resetForm(); // Reset the form fields to initial values
      // generatePdfDocument(finalDocument);
    },
    enableReinitialize: true,
  }); 
    const CoustomCertificategenerateCertificateForDelegate = useFormik({
    
    initialValues: {
      first_name: "",
      last_name: "",
      first_line: "",
      second_line: "",
      type: "",
      event_title: eventResponseFull?.title,
      event_id :eventResponseFull?.name,
      end_date: eventResponseFull?.end_date,
      country: eventResponseFull?.title,
      qr_text: "https://impactdirectors.org",
    },
    
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setCoustomCertificateFormDataImpactForDelegate(values);
      setIsFormSubmmitedCertificateForImpactForDelegate(true);
      toast.success("Certificate Generated Successfully");
      resetForm(); // Reset the form fields to initial values
      // generatePdfDocument(finalDocument);
    },
    enableReinitialize: true,
  }); 
  const generateCertificate = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      first_line: "",
      second_line: "",
      type: "",
      event_title: eventResponseFull?.title,
      end_date: eventResponseFull?.end_date,
      country: eventResponseFull?.country,
      qr_text: "https://bestdiplomats.org",
    },
    onSubmit: async (values, { resetForm }) => {
      // console.log(values);
      setCertificateFormData(values);
      setIsFormSubmmitedCertificate(true);
      toast.success("Certificate Generated Successfully");
      resetForm(); // Reset the form fields to initial values
      // generatePdfDocument(finalDocument);
    },
    enableReinitialize: true,
  });
  // Formik Configration for ID Card Genertation

  function uploadDocument(e, type) {
    const fileFlight = e.target.files[0];
    const formData = new FormData();
    formData.append("file", fileFlight);
    formData.append("is_private", 1);

    const uploadFileApi = async () => {
      try {
        await axios
          .post(
            "https://dash.bestdiplomats.org/api/method/upload_file",
            formData,
            config
          )
          .then(async (response) => {
            if(type == 'bank_receipt') {
              sendInviteForm.setFieldValue("bank_receipt", response?.data);
            }
            else if(type == 'invoice'){
              sendInviteForm.setFieldValue("invoice", response?.data);
            }
          });
      } catch (e) {
        console.log(e);
      }
    };
    uploadFileApi();
  }

  const sendInviteForm = useFormik({
    initialValues: {
      event: eventResponse,
    },
    
    onSubmit: async (values) => {
      let cleanedValues = { ...values };

    // Conditional logic to clear irrelevant fields
    if (["Accommodation", "Non-Accommodation"].includes(values.payment_package)) {
      cleanedValues.order_first_installment = "";
      cleanedValues.order_second_installment = "";
    } else {
      cleanedValues.order_number = "";
    }
    const sendInviteJSON = {
      invitation_email: cleanedValues.email?.toLowerCase().trim(),
      delegate_name: cleanedValues.delegate_name,
      representing_country: cleanedValues.representing_country,
      payment_package: cleanedValues.payment_package,
      package: cleanedValues.package,
      payment_mode: cleanedValues.payment_mode,
      order_number: cleanedValues.order_number,
      order_first_installment: cleanedValues.order_first_installment,
      order_second_installment: cleanedValues.order_second_installment,
      event: eventID,
      payment_date: cleanedValues.payment_date,
      invitation_status: "Pending",
      ...(cleanedValues.invoice
        ? { invoice: cleanedValues.invoice?.message?.file_url }
        : {}),
      ...(cleanedValues.bank_receipt
        ? { bank_receipt: cleanedValues.bank_receipt?.message?.file_url }
        : {}),
    };

      // const sendInviteJSON = {
      //   invitation_email: values.email.toLowerCase().trim(),
      //   delegate_name: values.delegate_name,
      //   representing_country: values.representing_country,
      //   payment_package: values.payment_package,
      //   package: values.package,
      //   payment_mode: values.payment_mode,
      //   order_number: values.order_number,
      //   order_second_installment: values.order_second_installment,
      //   order_first_installment: values.order_first_installment,
      //   package: values.package,
      //   event: eventID,
      //   payment_date: values.payment_date,
      //   invitation_status: "Pending",
      //   ...(values.invoice ? { invoice: values.invoice?.message?.file_url } : {}),
      //   ...(values.bank_receipt ? { bank_receipt: values.bank_receipt?.message?.file_url } : {})
      // };
      const sendInviteApi = async () => {
        try {
          const result = await axios
            .post(
              `https://dash.bestdiplomats.org/api/resource/Delegate Invitations`,
              sendInviteJSON,
              config
            )
            .then((response) => {
              toast.success("Invitation Sent Successfully");
            });
        } catch (e) {
          console.log(e);
          if (e.response.status == 409) {
            toast.error("Duplicate Entry Not Allowed");
          }
        }
      };
      sendInviteApi();
    },
    enableReinitialize: true,
  });
  // Formik Configration for Filters

  const [regUpdatedSuccess, setRegUpdatedSuccess] = useState(false);
  // Formik for Registeration Status
  const regStatusUpdate = useFormik({
    initialValues: {
      status_registration: detailPersonReg?.reg_status,
    },
    onSubmit: (values) => {
      var fullUniqueString =
        detailPersonReg.unique_representing_country_checker;
      var SplitUnique = fullUniqueString.split("-");
      var toUpdateUnique = `${SplitUnique[0]}-${SplitUnique[1]}-${values.status_registration}`;
      var JSONforUpdate = {
        reg_status: values.status_registration,
        unique_representing_country_checker: toUpdateUnique,
      };
      const UpdateRegStatus = async () => {
        try {
          const result = await axios
            .put(
              `https://dash.bestdiplomats.org/api/resource/Event Registration/${detailPersonReg.name}`,
              JSONforUpdate,
              config
            )
            .then((response) => {
              setRegUpdatedSuccess(true);
              setTimeout(() => {
                setRegUpdatedSuccess(false);
              }, 2000);
            });
        } catch (e) {
          console.log(e);
        }
      };
      UpdateRegStatus();
    },
    enableReinitialize: true,
  });
  // Function to get specific name change Request
  const [signleNameChangeRequest, setSingleNameChangeRequest] = useState(null);
  const [isImageName, setIsImageName] = useState(false);
  const [isPDFName, setIsPDFName] = useState(false);
  const getSpecificNameRequest = async (data) => {
    await setSingleNameChangeRequest(data);
    if (data.legal_file) {
      if (data.legal_file.length > 1) {
        var splitFile = data.legal_file;
        var split = splitFile.split(".");
        var final = split[split.length - 1];
        if (final == "pdf") {
          setIsPDFName(true);
          setIsImageName(false);
        } else {
          // console.log(final);
          setIsImageName(true);
          setIsPDFName(false);
        }
      }
    }

    setOpenDraw(true);
  };
  // Fromik for name change request

  // Profile Picture Cropper
  const [src, setSrc] = useState(null);
  const [preview, setPreview] = useState(
    "data:image/png;base64,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"
  );
  const [profilePictureUploaded, setProfilePictureUploaded] = useState(false);
  const [isCropingPicture, setIsCropingPicture] = useState(false);

  const onClose = () => {
    setPreview(null);
  };
  const onCrop = (view) => {
    setPreview(view);
    // console.log(preview);
  };
  const onPopUpClose = (view) => {
    setIsCropingPicture(false);
  };

  function cropFirst() {
    setIsCropingPicture(true);
  }

  // eventinvitation

  const [invitation, setInvitation] = useState(null);
  const [invitationCount, setInvitationCount] = useState(0);

  const [inviteFilter, setInviteFilter] = useState(
    `["event","=","${eventID}"]`
  );

  useEffect(() => {
    const geteventdata = async () => {
      const result = await axios
        .get(
          `https://dash.bestdiplomats.org/api/resource/Delegate Invitations?fields=["*"]&filters=[${inviteFilter}]&limit_page_length=999`
        )
        .then((res) => {
          setInvitationCount(res.data.data.length);
          setInvitation(res.data.data);
        })
        .catch((e) => {
          // console.log("eventinvitation errrrr", e);
        });
    };
    geteventdata();
  }, [inviteFilter]);

  const handleSelectChange = (event) => {
    const { value } = event.target;
    generateIdCard.setFieldValue("second_line", value);
  };
  const handleInputChange = (event) => {
    const { value } = event.target;
    generateIdCard.setFieldValue("second_line", value);
  };

  // Formik for Filter on Invitation
  const applyFiltersInvitation = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      setInviteFilter(`["event","=","${eventID}"]`);

      // console.log(values);
      //  Payment Package
      if (values.status) {
        if (values.status != "None") {
          setInviteFilter((prevState) => [
            prevState + `,["invitation_status","=","${values.status}"]`,
          ]);
        } else {
          setInviteFilter(`["event","=","${eventID}"]`);
        }
      }
    },
    enableReinitialize: true,
  });

  //   Call to get single event Registeration

  return (
    <>
      <Toaster position="bottom-left" richColors />
      <div>
        {regUpdatedSuccess && (
          <div className="flex ml-4 shadow-xl bg-green-100 w-96 rounded-lg p-4 mb-4 fixed z-10">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <CheckIcon
                className="h-6 w-6 text-green-600"
                aria-hidden="true"
              />
            </div>
            <span className="font-medium text-green-600 flex items-center">
              Registeration Updated Successfully
            </span>
          </div>
        )}
        {nameRequestUpdate && (
          <div className="flex ml-4 shadow-xl bg-green-100 w-96 rounded-lg p-4 mb-4 fixed z-10">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
              <CheckIcon
                className="h-6 w-6 text-green-600"
                aria-hidden="true"
              />
            </div>
            <span className="font-medium text-green-600 flex items-center">
              Request Updated Successfully
            </span>
          </div>
        )}

        <Disclosure
          as="div"
          className="relative overflow-hidden banner-back pb-32"
        >
          {({ open }) => (
            <>
              <div
                aria-hidden="true"
                className={classNames(
                  open ? "bottom-0" : "inset-y-0",
                  "absolute inset-x-0 left-1/2 w-full -translate-x-1/2 transform overflow-hidden lg:inset-y-0"
                )}
              >
                <div className="absolute inset-0 flex">
                  <div className="h-full w-1/2 banner-back" />
                  <div className="h-full w-1/2 banner-back" />
                </div>
                <div className="relative flex justify-center">
                  <svg
                    className="flex-shrink-0"
                    width={1750}
                    height={308}
                    viewBox="0 0 1750 308"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M284.161 308H1465.84L875.001 182.413 284.161 308z"
                      fill="#4591DC"
                    />
                    <path
                      d="M1465.84 308L16.816 0H1750v308h-284.16z"
                      fill="#4591DC"
                    />
                    <path
                      d="M1733.19 0L284.161 308H0V0h1733.19z"
                      fill="#4591DC"
                    />
                    <path
                      d="M875.001 182.413L1733.19 0H16.816l858.185 182.413z"
                      fill="#4591DC"
                    />
                  </svg>
                </div>
              </div>
              <header className="relative py-10">
                <div className="mx-auto max-w-screen px-4 sm:px-6 lg:px-8">
                  {localStorage.role == "Director Ambassador" ? (
                    <h1 className="text-3xl font-bold tracking-tight text-white">
                      Representative Dashboard
                    </h1>
                  ) : (
                    <h1 className="text-3xl font-bold tracking-tight text-white">
                      Operations Team Dashboard ({eventResponse})
                    </h1>
                  )}
                </div>
              </header>
            </>
          )}
        </Disclosure>
        {/* <div className=" absolute top-14 left-6">
          {isDone && <Done text="Done" color="green" />}
        </div> */}
        <div className=" absolute top-14 left-6">
          {isNotFound && <Done text="No Data Found" color="red" />}
        </div>
        {/* <div className=" absolute top-14 left-6">
          {isDuplicate && (
            <Done text="Duplicate Entry Not Allowed" color="red" />
          )}
        </div> */}
        <main className="relative  -mt-32">
          <div className="mx-auto max-w-screen px-4 pb-6 sm:px-6 lg:px-8 lg:pb-16">
            <div className="overflow-hidden  ring-1 ring-white rounded-md bg-white ">
              <div className="  lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
                <aside className="py-6 border-white banner-back lg:col-span-3">
                  {localStorage.role == "Operations Member" ? (
                    <nav className="space-y-1 px-2 pb-16">
                      {currentNavigation.length > 0 &&
                        currentNavigation.map((item, index) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className={classNames(
                              item.current
                                ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                                : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                              "group flex items-center rounded-md px-2 py-2 text-sm font-medium"
                            )}
                            onClick={() =>
                              handleClickNavigation(index, setCurrentNavigation)
                            }
                          >
                            <item.icon
                              className={classNames(
                                item.current
                                  ? "text-white"
                                  : "text-white group-hover:text-white",
                                "mr-4 h-6 w-6 flex-shrink-0 now "
                              )}
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        ))}{" "}
                      {/* Invite New Delegate */}
                      <button
                        onClick={() => {
                          setOnSendInvite(true);
                        }}
                        className={classNames(
                          onSendInvite
                            ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                            : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                          "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                        )}
                        aria-current={onSendInvite ? "page" : undefined}
                      >
                        <UserPlusIcon
                          className={classNames(
                            onSendInvite
                              ? "text-white group-hover:text-white"
                              : "text-white group-hover:text-white",
                            "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        <span>Invite New Delegate</span>
                      </button>
                      {/* Generate ID Card Button */}
                      <Menu
                        as="div"
                        className="relative inline-block text-left opacity-100 z-50   py-1 w-full"
                      >
                        <div>
                          <Menu.Button  onClick={() => {}} className="flex justify-between  w-full  text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-2 py-2  items-center text-sm font-medium">
                            <span className="flex items-center">
                              <DocumentTextIcon className="h-6 w-6 mr-2" />{" "}
                              Generate Custom ID Card
                            </span>
                            <ChevronDownIcon
                              className="-mr-1 h-5 w-5 text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-full origin-top-right  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(true);
                                    setIsFormSubmmited(false);
                                    onClose(null);
                                    setProfilePictureUploaded(false);
                                    setIsCropingPicture(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setOnGenAwarCertificate(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />ID Card For Best Diplomats{" "}
                              
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCardForImpactDirector(true);
                                    onClose(null);
                                    setIsFormSubmmited(false);
                                    setProfilePictureUploaded(false);
                                    setIsCropingPicture(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setOnGenAwarCertificate(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />ID Card For Impact Director{" "}
                              
                                  </a>
                                
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      {/* <button
                        onClick={() => {
                          setOnGenIDCard(true);
                          onClose(null);
                          setProfilePictureUploaded(false);
                          setIsCropingPicture(false);
                          setOnGenCertificate(false);
                          setOnGenCoustomCertificateForimpact(false);
                          setOnGenAwarCertificate(false);
                        }}
                        className={classNames(
                          onGenIDCard
                            ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                            : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                          "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                        )}
                        aria-current={onGenIDCard ? "page" : undefined}
                      >
                        <IdentificationIcon
                          className={classNames(
                            onGenIDCard
                              ? "text-white group-hover:text-white"
                              : "text-white group-hover:text-white",
                            "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        <span className="truncate">
                          Generate Custom ID Card
                        </span>
                      </button> */}
                      {/* Generate Award Certificate Button */}
                      <Menu
                        as="div"
                        className="relative inline-block text-left opacity-100 z-40   py-1 w-full"
                      >
                        <div>
                          <Menu.Button  onClick={() => {}} className="flex justify-between  w-full  text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-2 py-2  items-center text-sm font-medium">
                            <span className="flex items-center">
                              <DocumentTextIcon className="h-6 w-6 mr-2" />{" "}
                              Generate Custom Award Certificate
                            </span>
                            <ChevronDownIcon
                              className="-mr-1 h-5 w-5 text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-full origin-top-right  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setOnForimpactDirectorGenAwarCertificate(false);
                                    setOnGenAwarCertificate(true);
                                    setIsFormSubmmitedAwardCertificate(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificate(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificateForguest(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />Certificates For Best Diplomats{" "}
                              
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificate(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificateForguest(false);
                                    setOnForimpactDirectorGenAwarCertificate(true);
                                    setOnGenAwarCertificate(false);
                                    setIsFormSubmmitedAwardCertificate(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />Award Certificates For Impact Director{" "}
                              
                                  </a>
                                
                                )}
                              </Menu.Item> <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificate(false);
                                    setIsFormSubmmitedimpactDirectorAwardCertificateForguest(false);
                                    setOnForimpactDirectorGenAwarCertificate(false);
                                    setOnForimpactDirectorGenAwarCertificateForGuest(true);
                                    setOnGenAwarCertificate(false);
                                    setIsFormSubmmitedAwardCertificate(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        /> Guest Speaker Certificate For Impact Directors{" "}
                              
                                  </a>
                                
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      {/* <button
                        onClick={() => {
                          setOnGenIDCard(false);
                          setOnGenCertificate(false);
                          setOnGenAwarCertificate(true);
                          setIsFormSubmmitedAwardCertificate(false);
                        }}
                        className={classNames(
                          onGenAwarCertificate
                            ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                            : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                          "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                        )}
                        aria-current={onGenAwarCertificate ? "page" : undefined}
                      >
                        <CreditCardIcon
                          className={classNames(
                            onGenAwarCertificate
                              ? "text-white group-hover:text-white"
                              : "text-white group-hover:text-white",
                            "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        <span className="truncate">
                          Generate Custom Award Certificate
                        </span>
                      </button> */}
                      {/* Generate Certificate Button */}
                      <Menu
                        as="div"
                        className="relative inline-block text-left opacity-100 z-30  py-1 w-full"
                      >
                        <div>
                          <Menu.Button className="flex justify-between  w-full  text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-2 py-2  items-center text-sm font-medium">
                            <span className="flex items-center">
                              <DocumentTextIcon className="h-6 w-6 mr-2" />{" "}
                              Generate Custom Certificate
                            </span>
                            <ChevronDownIcon
                              className="-mr-1 h-5 w-5 text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-full origin-top-right  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(true);
                                    setOnGenCoustomCertificateForimpact(false);
                                    setOnGenAwarCertificate(false);
                                    setIsFormSubmmitedCertificate(false);
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 hover:bg-gray-200 cursor-pointer flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />Certificates For Best Diplomats{" "}
                              
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpact(true);
                                    setIsFormSubmmitedCertificateForImpact(false)
                                    setOnGenAwarCertificate(false);
                                    setIsFormSubmmitedCertificate(false);
                                    CoustomCertificategenerateCertificate.resetForm()
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />Local&Core Team Certificates For Impact Directors{" "}
                              
                                  </a>
                                
                                )}
                              </Menu.Item> 
                               <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  onClick={() => {
                                    setOnGenIDCard(false);
                                    setOnGenCertificate(false);
                                    setOnGenCoustomCertificateForimpactForDelegate(true);
                                    setIsFormSubmmitedCertificateForImpactForDelegate(false)
                                    setOnGenAwarCertificate(false);
                                    setIsFormSubmmitedCertificate(false);
                                    CoustomCertificategenerateCertificateForDelegate.resetForm()
                                  }}
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm gap-2 cursor-pointer hover:bg-gray-200 flex"
                                    )}
                                  >
                                         <CreditCardIcon
                          className={ " h-6 w-6"
                          }
                          aria-hidden="true"
                        />Delegate Certificates For Impact Directors{" "}
                              
                                  </a>
                                
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      {/* <button
                        onClick={() => {
                          setOnGenIDCard(false);
                          setOnGenCertificate(true);
                          setOnGenCoustomCertificateForimpact(false);
                          setOnGenAwarCertificate(false);
                          setIsFormSubmmitedCertificate(false);
                        }}
                        className={classNames(
                          onGenCertificate
                            ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                            : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                          "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                        )}
                        aria-current={onGenCertificate ? "page" : undefined}
                      >
                        <CreditCardIcon
                          className={classNames(
                            onGenCertificate
                              ? "text-white group-hover:text-white"
                              : "text-white group-hover:text-white",
                            "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        <span className="truncate">
                          Generate Custom Certificate
                        </span>
                      </button> */}
                      <a
                        href={window.$FWDurl + "/DiplomaticStance/" + eventID}
                        target="_blank"
                        className="flex justify-start text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-3 py-2  items-center text-sm font-medium"
                      >
                        <DocumentTextIcon className="h-6 w-6 mr-2" />
                        <span>Download All Diplomatic Stance </span>
                        <svg
                          className="w-5 h-5 ml-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          ></path>
                        </svg>
                      </a>
                      <Menu
                        as="div"
                        className="relative inline-block text-left opacity-100 z-20   py-1 w-full"
                      >
                        <div>
                          <Menu.Button className="flex justify-between  w-full  text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-3 py-2  items-center text-sm font-medium">
                            <span className="flex items-center">
                              <DocumentTextIcon className="h-6 w-6 mr-2" />{" "}
                              Download All Certificates
                            </span>
                            <ChevronDownIcon
                              className="-mr-1 h-5 w-5 text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-full origin-top-right  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                    href={
                                      window.$FWDurl +
                                      "/CertificateAll/" +
                                      eventID
                                    }
                                    target="_blank"
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm justify-between hover:bg-gray-200 flex"
                                    )}
                                  >
                                   Download Certificates For Best Diplomats{" "}
                                    <svg
                                      className="w-5 h-5 "
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                      ></path>
                                    </svg>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                    href={
                                      window.$FWDurl +
                                      "/DownloadCertificateForImpactDirectors/" +
                                      eventID
                                    }
                                    target="_blank"
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex px-2 py-2 text-sm justify-between hover:bg-gray-200"
                                    )}
                                  >
                                  Download Certificates For Impact Directors{" "}
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                      ></path>
                                    </svg>
                                  </a>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      {/* <a
                        href={window.$FWDurl + "/CertificateAll/" + eventID}
                        target="_blank"
                        className="flex justify-start text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-3 py-2  items-center text-sm font-medium"
                      >
                        <DocumentTextIcon className="h-6 w-6 mr-2" />
                        <span>Download All Certificates </span>
                        <svg
                          className="w-5 h-5 ml-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          ></path>
                        </svg>
                      </a> */}
                       <Menu
                        as="div"
                        className="relative inline-block text-left py-1 w-full"
                      >
                        <div>
                          <Menu.Button className="flex justify-between  w-full  text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-3 py-2  items-center text-sm font-medium">
                            <span className="flex items-center">
                              <DocumentTextIcon className="h-6 w-6 mr-2" />{" "}
                              Download All ID Cards
                            </span>
                            <ChevronDownIcon
                              className="-mr-1 h-5 w-5 text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>

                        <Transition
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-10 mt-2 w-full origin-top-right  rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                            <div className="py-1">
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  href={window.$FWDurl + "/IDCardBulk/" + eventID}
                                    target="_blank"
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      " px-2 py-2 text-sm justify-between hover:bg-gray-200 flex"
                                    )}
                                  >
                                   Download ID Cards For Best Diplomats{" "}
                                    <svg
                                      className="w-5 h-5 "
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                      ></path>
                                    </svg>
                                  </a>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ focus }) => (
                                  <a
                                  href={window.$FWDurl + "/id-card-impact/" + eventID}
                                    target="_blank"
                                    className={classNames(
                                      focus
                                        ? "bg-gray-100 text-gray-900"
                                        : "text-gray-700",
                                      "flex px-2 py-2 text-sm justify-between hover:bg-gray-200"
                                    )}
                                  >
                                  Download ID Cards For Impact Directors{" "}
                                    <svg
                                      className="w-5 h-5"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                                      ></path>
                                    </svg>
                                  </a>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                      {/* <a
                        href={window.$FWDurl + "/IDCardBulk/" + eventID}
                        target="_blank"
                        className="flex justify-start text-white group hover:text-white rounded-md hover:bg-blue-600 border-l-4 px-3 py-2  items-center text-sm font-medium"
                      >
                        <DocumentTextIcon className="h-6 w-6 mr-2" />
                        <span>Download All ID Cards </span>
                        <svg
                          className="w-5 h-5 ml-1"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          ></path>
                        </svg>
                      </a> */}
                    </nav>
                  ) : localStorage.role == "Operations Team" ? (
                    <nav className="space-y-1 px-2 pb-16">
                      {currentNavigationOperationTeam.map((item, index) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                              : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                            "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          )}
                          onClick={() => handleClickNavigationteam(index)}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </nav>
                  ) : localStorage.role == "Bag Allocation" ? (
                    <nav className="space-y-1 h-screen px-2 pb-16">
                      {bagAllocation.map((item, index) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                              : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                            "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          )}
                          onClick={() => handleClickBagAllocation(index)}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </nav>
                  ) : localStorage.role == "Self Checkin Hotel Access" ? (
                    <nav className="space-y-1 h-screen px-2 pb-16">
                      {SelfCheckin.map((item, index) => (
                        <NavLink
                          key={item.name}
                          to={item.href}
                          className={"border-transparent  hover:bg-blue-600  text-white hover:text-white group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          }
                          >
                          {/* bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white */}
                          {/* onClick={() =>
                            handleClickNavigationSelfCheckin(index)
                          } */}
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </NavLink>
                      ))}
                    </nav>
                  ) : localStorage.role == "Chat Department" ||
                    localStorage.role == "Academics Department" ? (
                    <nav className="space-y-1 h-96 px-2 pb-16">
                      {currentNavigationChatManager.map((item, index) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                              : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                            "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          )}
                          onClick={() =>
                            handleClickNavigationChatManager(index)
                          }
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </nav>
                  ) : localStorage.role == "Communication Department" ? (
                    <nav className="space-y-1 h-96 px-2 pb-16">
                      {currentNavigationCommunicationManager.map(
                        (item, index) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className={classNames(
                              item.current
                                ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                                : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                              "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                            )}
                            onClick={() =>
                              handleClickNavigationCommunicationManager(index)
                            }
                          >
                            <item.icon
                              className={classNames(
                                item.current
                                  ? "text-white group-hover:text-white"
                                  : "text-white group-hover:text-white",
                                "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                              )}
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        )
                      )}
                    </nav>
                  ) : localStorage.role == "Support Team" ? (
                    <nav className="space-y-1 h-96 px-2 pb-16">
                      {currentNavigationSupportTeam.map((item, index) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                              : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                            "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          )}
                          onClick={() =>
                            handleClickNavigationSupportTeam(index)
                          }
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </nav>
                  ) : localStorage.role == "Director Ambassador" ? (
                    <nav className="space-y-1 h-screen px-2 pb-16">
                      {currentNavigationDirectorAmbassador.map(
                        (item, index) => (
                          <Link
                            key={item.name}
                            to={item.href}
                            className={classNames(
                              item.current
                                ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                                : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                              "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                            )}
                            onClick={() => handleClickDirectorAmbassador(index)}
                          >
                            <item.icon
                              className={classNames(
                                item.current
                                  ? "text-white group-hover:text-white"
                                  : "text-white group-hover:text-white",
                                "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                              )}
                              aria-hidden="true"
                            />
                            {item.name}
                          </Link>
                        )
                      )}
                    </nav>
                  ) : (
                    <nav className="space-y-1 h-96 px-2 pb-16">
                      {currentNavigationDelegatesManager.map((item, index) => (
                        <Link
                          key={item.name}
                          to={item.href}
                          className={classNames(
                            item.current
                              ? "bg-blue-700 border-blue-700 text-white hover:bg-blue-600 hover:text-white"
                              : "border-transparent text-white hover:bg-blue-600 hover:text-white",
                            "group flex items-center w-full rounded-md px-2 py-2 text-sm font-medium"
                          )}
                          onClick={() =>
                            handleClickNavigationDelegatesManager(index)
                          }
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-white group-hover:text-white"
                                : "text-white group-hover:text-white",
                              "flex-shrink-0 -ml-1 mr-3 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </Link>
                      ))}
                    </nav>
                  )}
                </aside>

                <div className="divide-y  lg:col-span-9 pt-4 p-5">
                  {localStorage.role === "Support Team" ? (
                    <Routes>
                      <Route
                        path="/ticket-details/:eventID"
                        element={<Ticket />}
                      />

                      <Route
                        path="/chat-request/:eventID"
                        element={<Chat eventResponse={eventResponse} />}
                      />
                    </Routes>
                  ) : (
                    <Routes>
                      <Route
                        path="/registration-navbar/:eventID/*"
                        element={<RegistrationdNavBar />}
                      />
                      <Route
                        path="/apply-for-event"
                        element={<ApplyForEvents />}
                      />
                      <Route
                        path="/checkInAllTypeRegistration-event/:eventID/*"
                        element={<CheckinNavbar />}
                      />
                      <Route
                        path="/invitation-event/:eventID"
                        element={<Invitationevent />}
                      />   
                      <Route
                        path="/extra-night-stay/:eventID"
                        element={<ExtraNightStays />}
                      />
                      <Route
                        path="/audit-log/:eventID"
                        element={<AuditLog />}
                      />
                      <Route
                        path="/audit-log/:eventID/:delegateProfileId"
                        element={<AuditLogDetail />}
                      />
                      <Route
                        path="/pri-breakdown/:eventID"
                        element={<PricingBreakDown />}
                      />
                      <Route
                        path="/roomallocation/:eventID"
                        element={<RoomAllocation />}
                      />
                      <Route
                        path="/room-sharing/:eventID"
                        element={<RoomSh />}
                      />
                      <Route
                        path="/self-checkin-hotel-access/:eventID"
                        element={<SelfCheckinHotel />}
                      />
                      <Route
                        path="/hotel-rooms/:eventID"
                        element={<HotelRooms />}
                      />
                      <Route
                        path="/name-change-request/:eventID"
                        element={<NameChngReq />}
                      />
                      <Route
                        path="/culture-prfomis/:eventID"
                        element={<CulturePrfo />}
                      />
                      <Route
                        path="/create-events/:eventID"
                        element={<CreateEventa />}
                      />
                      <Route
                        path="/send-invitataion-events/:eventID"
                        element={<SendInvitationEvent />}
                      />
                      <Route path="/ambassador-ops" element={<Ambassdor />} />
                      <Route
                        path="/country-rep/statistics/*"
                        element={<AnalyticsDashboard />}
                      />
                      <Route
                        path="/country-rep/:eventID/*"
                        element={<RepresentativeNavbar />}
                      />
                      <Route
                        path="/diplomatic-nav/:eventID/*"
                        element={<DiplomaticExpertsNavbar />}
                      />
                      <Route
                        path="/leads_profile/:eventID"
                        element={<LeadsProfile />}
                      />
                      <Route
                        path="/upgrades-center/:eventID"
                        element={<Upgrades />}
                      />
                      <Route
                        path="/ticket-details/:eventID"
                        element={<Ticket />}
                      />
                      <Route
                        path="/email-send/:eventID"
                        element={<EmailSend />}
                      />
                      <Route
                        path="/transfer-request"
                        element={<Registrationstatus />}
                      />
                      <Route 
                        path="transfer-request/:requestId" 
                        element={<TransferRequestDetailPage />}
                        />
                      <Route
                        path="/scholarship-applications"
                        element={<ScholarshipApplications />}
                      />
                      <Route
                        path="/scholarship-applications/:applicationID"
                        element={<ScholarshipApplicationDetail />}
                      />
                      <Route
                        path="/scholarship-tasks"
                        element={<ScholarshipTasks />}
                      />
                      <Route
                        path="/scholarship-tasks/:taskID"
                        element={<ScholarshipTaskDetails />}
                      />
                      <Route
                        path="/cr-payment"
                        element={<CrPayment />}
                      />
                  <Route path="/event-itinerary/:eventID" exist element={<EventItineraryNavBar />}>
                  <Route index element={<EventItinerary />} />
                  <Route path="add-new-itinerary/:eventID" element={<AddNewItinerary />} />
                  <Route path="itinerary-details/:eventID/:Id" element={<EventItineraryDetails />} />
                  </Route>
                       {/* <Route
                        path="/event-itinerary/:eventID"
                        element={<EventItinerary />}
                      /> */}
                      <Route
                        path="/conference-feedback/:eventID"
                        element={<ConferenceFeedBack />}
                      />
                      <Route
                        path="/non-acc-checkin/:eventID"
                        element={<NonAccCheckin />}
                      />
                      <Route
                        path="/assign-bag/:eventID"
                        element={<AssignBag />}
                      />{" "}
                      <Route
                        path="/assign-bag-for-checkin/:eventID"
                        element={<BagAllocationSelfCheckin />}
                      />
                      <Route
                        path="/chat-request/:eventID"
                        element={<Chat eventResponse={eventResponse} />}
                      />
                      <Route
                        path="/announcement-center/:eventID"
                        element={<Announcement eventResponse={eventResponse} />}
                      />
                    </Routes>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Drawer for details */}

      {/* Drawer for ID Card Generation */}
      <Transition.Root show={onGenIDCard} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOnGenIDCard}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full ">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateIdCard.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom ID Card
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenIDCard(false);
                                  setIsFormSubmmited(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg w-[20rem]  font-semibold">
                            Fields Required to Generate ID Card
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.last_name}
                              required
                              className="mt-1 block w-full  rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First Line
                            </label>
                            <textarea
                              type="text"
                              name="first_line"
                              id="first_line"
                              maxlength="35"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.first_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                            <span className=" font-extralight text-gray-600 align-middle content-center text-sm">
                              Maximum character allowed 35
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="for"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Title For Attendee
                            </label>
                            <select
                              type="text"
                              name="for"
                              id="for"
                              onChange={handleSelectChange}
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>
                              <option value="Director General">
                                Director General
                              </option>
                              <option value="Project Manager">
                                Project Manager
                              </option>
                              <option value="Local Team Members">
                                Local Team Members
                              </option>
                              <option value="Ambassadors">Ambassadors</option>
                              <option value="Guests">Guests</option>
                              <option value="Operations Team">
                                Operations Team
                              </option>
                              <option value="Speakers and Guest of Honours">
                                Speakers and Guest of Honours
                              </option>
                            </select>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="second_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Second Line
                            </label>
                            <textarea
                              type="text"
                              name="second_line"
                              id="second_line"
                              value={generateIdCard.values.second_line}
                              onChange={handleInputChange}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                            <span className=" font-extralight text-gray-600 align-middle content-center text-sm">
                              Maximum character allowed 42
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="event_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Event Name
                            </label>
                            <input
                              type="text"
                              name="event_name"
                              id="event_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.event_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="color"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Color
                            </label>
                            <select
                              type="text"
                              name="color"
                              id="color"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.color}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="Blue">Blue</option>
                              <option value="Black">Black</option>
                              <option value="Gold">Gold</option>
                            </select>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="user_image"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Picture
                              <span className="text-red-500">*</span>
                            </label>
                            <input type="file" className="sr-only" />

                            <div className="flex flex-row gap-4 items-center">
                              <button
                                onClick={() => {
                                  setIsCropingPicture(true);
                                  setProfilePictureUploaded(false);
                                  setPreview(false);
                                }}
                                type="button"
                                className="mt-4 text-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                              >
                                Upload Picture
                              </button>
                              {profilePictureUploaded ? (
                                <span className="text-green-700 ">
                                  Picture Uploaded
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {isFormSubmmited && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                ID Card
                              </span>
                              <PDFDownloadLink
                                document={
                                  <IdCardAll
                                    profileImage={preview}
                                    payment_package={idCardFormData?.color}
                                    firstName={idCardFormData?.first_name}
                                    lastName={idCardFormData?.last_name}
                                    firstLine={idCardFormData?.first_line}
                                    secondLine={idCardFormData?.second_line}
                                    qrText={idCardFormData?.qr_text}
                                    eventName={idCardFormData?.event_name}
                                  />
                                }
                                fileName={`IDCard-${idCardFormData?.first_name}.pdf`}
                              >
                                {" "}
                                <span
                                  onClick={() => {
                                    generateIdCard.resetForm();
                                    setTimeout(() => {
                                      setIsFormSubmmited(false);
                                      setProfilePictureUploaded(false);
                                      setPreview(null);
                                    }, 1500);
                                  }}
                                  className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full sm:col-span-2 rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>

                          {/* Cropper Popup */}
                          {isCropingPicture ? (
                            <div className="flex flex-col justify-center mt-0 bg-gray-100 bg-opacity-75 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 md:inset-0 h-modal h-full">
                              <div className="flex justify-center pt-[6rem]">
                                <Avatar
                                  width={300}
                                  height={200}
                                  onCrop={onCrop}
                                  exportSize={500}
                                  onClose={onClose}
                                  src={src}
                                ></Avatar>
                              </div>
                              <div className="mt-12 flex justify-center ">
                                {preview && (
                                  <img
                                    className="border-4 border-blue-400 w-[16rem] rounded"
                                    src={preview}
                                    alt="Cropped Image"
                                  />
                                )}
                                {/* {console.log(preview)} */}
                              </div>
                              <div className="mt-12 flex flex-row justify-center ">
                                <button
                                  onClick={() => {
                                    setProfilePictureUploaded(true);
                                    onPopUpClose();
                                  }}
                                  type="none"
                                  className="rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  Done
                                </button>
                                <button
                                  onClick={onPopUpClose}
                                  className="rounded-md border  border-transparent ml-4 bg-red-400 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          ) : null}

                          {/* <CropperComp /> */}
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenIDCard(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root> 
      {/* Drawer for ID Card Generation Impact Director */}
      <Transition.Root show={onGenIDCardForImpactDirector} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOnGenIDCardForImpactDirector}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full ">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateIdCard.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom ID Card
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenIDCardForImpactDirector(false);
                                  setIsFormSubmmited(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg w-[20rem]  font-semibold">
                            Fields Required to Generate ID Card
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.last_name}
                              required
                              className="mt-1 block w-full  rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First Line
                            </label>
                            <textarea
                              type="text"
                              name="first_line"
                              id="first_line"
                              maxlength="35"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.first_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                            <span className=" font-extralight text-gray-600 align-middle content-center text-sm">
                              Maximum character allowed 35
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="for"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Title For Attendee
                            </label>
                            <select
                              type="text"
                              name="for"
                              id="for"
                              onChange={handleSelectChange}
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>
                              <option value="Director General">
                                Director General
                              </option>
                              <option value="Project Manager">
                                Project Manager
                              </option>
                              <option value="Local Team Members">
                                Local Team Members
                              </option>
                              <option value="Ambassadors">Ambassadors</option>
                              <option value="Guests">Guests</option>
                              <option value="Operations Team">
                                Operations Team
                              </option>
                              <option value="Speakers and Guest of Honours">
                                Speakers and Guest of Honours
                              </option>
                            </select>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="second_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Second Line
                            </label>
                            <textarea
                              type="text"
                              name="second_line"
                              id="second_line"
                              value={generateIdCard.values.second_line}
                              onChange={handleInputChange}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                            <span className=" font-extralight text-gray-600 align-middle content-center text-sm">
                              Maximum character allowed 42
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="event_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Event Name
                            </label>
                            <input
                              type="text"
                              name="event_name"
                              id="event_name"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.event_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="color"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Color
                            </label>
                            <select
                              type="text"
                              name="color"
                              id="color"
                              onChange={generateIdCard.handleChange}
                              value={generateIdCard.values.color}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="Blue">Blue</option>
                              <option value="Black">Black</option>
                              <option value="Gold">Gold</option>
                            </select>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="user_image"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Picture
                              <span className="text-red-500">*</span>
                            </label>
                            <input type="file" className="sr-only" />

                            <div className="flex flex-row gap-4 items-center">
                              <button
                                onClick={() => {
                                  setIsCropingPicture(true);
                                  setProfilePictureUploaded(false);
                                  setPreview(false);
                                }}
                                type="button"
                                className="mt-4 text-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                              >
                                Upload Picture
                              </button>
                              {profilePictureUploaded ? (
                                <span className="text-green-700 ">
                                  Picture Uploaded
                                </span>
                              ) : null}
                            </div>
                          </div>
                          {isFormSubmmited && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                ID Card
                              </span>
                              <PDFDownloadLink
                                document={
                                  <AllIDCardForImpactDirector
                                    profileImage={preview}
                                    payment_package={idCardFormData?.color}
                                    firstName={idCardFormData?.first_name}
                                    lastName={idCardFormData?.last_name}
                                    firstLine={idCardFormData?.first_line}
                                    secondLine={idCardFormData?.second_line}
                                    qrText={idCardFormData?.qr_text}
                                    eventName={idCardFormData?.event_name}
                                  />
                                }
                                fileName={`IDCard-${idCardFormData?.first_name}.pdf`}
                              >
                                {" "}
                                <span
                                  onClick={() => {
                                    generateIdCard.resetForm();
                                    setTimeout(() => {
                                      setIsFormSubmmited(false);
                                      setProfilePictureUploaded(false);
                                      setPreview(null);
                                    }, 1500);
                                  }}
                                  className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full sm:col-span-2 rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>

                          {/* Cropper Popup */}
                          {isCropingPicture ? (
                            <div className="flex flex-col justify-center mt-0 bg-gray-100 bg-opacity-75 overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 md:inset-0 h-modal h-full">
                              <div className="flex justify-center pt-[6rem]">
                                <Avatar
                                  width={300}
                                  height={200}
                                  onCrop={onCrop}
                                  exportSize={500}
                                  onClose={onClose}
                                  src={src}
                                ></Avatar>
                              </div>
                              <div className="mt-12 flex justify-center ">
                                {preview && (
                                  <img
                                    className="border-4 border-blue-400 w-[16rem] rounded"
                                    src={preview}
                                    alt="Cropped Image"
                                  />
                                )}
                                {/* {console.log(preview)} */}
                              </div>
                              <div className="mt-12 flex flex-row justify-center ">
                                <button
                                  onClick={() => {
                                    setProfilePictureUploaded(true);
                                    onPopUpClose();
                                  }}
                                  type="none"
                                  className="rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  Done
                                </button>
                                <button
                                  onClick={onPopUpClose}
                                  className="rounded-md border  border-transparent ml-4 bg-red-400 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          ) : null}

                          {/* <CropperComp /> */}
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenIDCardForImpactDirector(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Generate Award Certificate */}
      <Transition.Root show={onGenAwarCertificate} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnGenAwarCertificate}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateAwardCertificate.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom Certificate For Diplomats
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenAwarCertificate(false);
                                  setIsFormSubmmited(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateAwardCertificate.handleChange}
                              value={generateAwardCertificate.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateAwardCertificate.handleChange}
                              value={generateAwardCertificate.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              onChange={generateAwardCertificate.handleChange}
                              value={generateAwardCertificate.values.type}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={generateAwardCertificate.handleChange}
                              value={generateAwardCertificate.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              id="country"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateAwardCertificate.handleChange}
                              value={generateAwardCertificate.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedAwardCertificate && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <AwardCertificate
                                    FirstName={
                                      awardCertificateFormData.first_name
                                    }
                                    LastName={
                                      awardCertificateFormData.last_name
                                    }
                                    end_date={awardCertificateFormData.end_date}
                                    country={awardCertificateFormData.country}
                                    qrText={awardCertificateFormData.qr_text}
                                    type={awardCertificateFormData.type.toUpperCase()}
                                    event={eventResponseFull}
                                  />
                                }
                                fileName={`Certificate-${awardCertificateFormData?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenAwarCertificate(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root> 
      <Transition.Root show={onGenimpactDirectorAwarCertificate} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnForimpactDirectorGenAwarCertificate}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateAwardCertificateimpactDirector.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom Certificate For Impact Directors
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnForimpactDirectorGenAwarCertificate(false);
                                  setIsFormSubmmitedimpactDirectorAwardCertificate(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.type}
                              // value="OF AWARD"
                              disabled
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                           <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="title"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Title
                            </label>
                            <input
                              type="text"
                              name="title"
                              id="title"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.title}
                              // value="OF AWARD"
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              id="country"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateAwardCertificateimpactDirector.handleChange}
                              value={generateAwardCertificateimpactDirector.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedimpactDirectorAwardCertificate && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <AwardCertificateForImpactDirector
                                    FirstName={
                                      awardCertificateFormDataForImpact.first_name
                                    }
                                    LastName={
                                      awardCertificateFormDataForImpact.last_name
                                    }
                                    end_date={awardCertificateFormDataForImpact.end_date}
                                    country={awardCertificateFormDataForImpact.country}
                                    eventid={awardCertificateFormDataForImpact.event_id}
                                    qrText={awardCertificateFormDataForImpact.qr_text}
                                    eventtitle={awardCertificateFormDataForImpact.event_title}
                                    type={awardCertificateFormDataForImpact.type.toUpperCase()}
                                    title={awardCertificateFormDataForImpact.title.toUpperCase()}
                                    event={eventResponseFull}
                                  />
                                }
                                fileName={`Certificate-${awardCertificateFormDataForImpact?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download dfvdver 
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnForimpactDirectorGenAwarCertificate(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root> 
      <Transition.Root show={onGenimpactDirectorAwarCertificateForGuest} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnForimpactDirectorGenAwarCertificateForGuest}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateAwardCertificateimpactDirectorForGuest.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Guest Speaker Certificate For Impact Directors
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnForimpactDirectorGenAwarCertificate(false);
                                  setIsFormSubmmitedimpactDirectorAwardCertificateForguest(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              disabled
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.type}
                              // value="OF AWARD"
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                           <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="title"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Title
                            </label>
                            <input
                              type="text"
                              name="title"
                              id="title"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.title}
                              // value="OF AWARD"
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              id="country"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateAwardCertificateimpactDirectorForGuest.handleChange}
                              value={generateAwardCertificateimpactDirectorForGuest.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedimpactDirectorAwardCertificateForguest && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <AwardCertificateForGuest
                                    FirstName={
                                      awardCertificateFormDataForImpactForGuest.first_name
                                    }
                                    LastName={
                                      awardCertificateFormDataForImpactForGuest.last_name
                                    }
                                    end_date={awardCertificateFormDataForImpactForGuest.end_date}
                                    country={awardCertificateFormDataForImpactForGuest.country}
                                    qrText={awardCertificateFormDataForImpactForGuest.qr_text}
                                    eventtitle={awardCertificateFormDataForImpactForGuest.event_title}
                                    eventid={awardCertificateFormDataForImpactForGuest.event_id}
                                    type={awardCertificateFormDataForImpactForGuest.type.toUpperCase()}
                                    title={awardCertificateFormDataForImpactForGuest.title.toUpperCase()}
                                    event={eventResponseFull}
                                  />
                                }
                                fileName={`Certificate-${awardCertificateFormDataForImpactForGuest?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download dfvdver 
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnForimpactDirectorGenAwarCertificate(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      {/* Generate For Impact Certificate */}
      <Transition.Root show={onGenCoustomCertificateForimpact} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnGenCoustomCertificateForimpact}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={CoustomCertificategenerateCertificate.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom Certificate For Impact Director
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenCoustomCertificateForimpact(false);
                                  setIsFormSubmmitedCertificateForImpact(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          {/* <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.type}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div> */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Title
                            </label>
                            <textarea
                              type="text"
                              name="first_line"
                              id="first_line"
                              maxlength="150"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.first_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          {/* <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="second_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Second Line
                            </label>
                            <textarea
                              type="text"
                              name="second_line"
                              id="second_line"
                              maxlength="50"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.second_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div> */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              autoComplete="false"
                              id="country"
                              readOnly="true"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedCertificateForImpact && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <CoustomCertificateForimpactDirector
                                    FirstName={coustomcertificateFormDataImpact.first_name}
                                    LastName={coustomcertificateFormDataImpact.last_name}
                                    first_line={coustomcertificateFormDataImpact.first_line}
                                    second_line={coustomcertificateFormDataImpact.second_line}
                                    end_date={coustomcertificateFormDataImpact.end_date}
                                    eventid={coustomcertificateFormDataImpact.event_id}
                                    country={coustomcertificateFormDataImpact.country}
                                    qrText={coustomcertificateFormDataImpact.qr_text}
                                    type={coustomcertificateFormDataImpact.type.toUpperCase()}
                                    
                                  />
                                }
                                fileName={`Certificate-${coustomcertificateFormDataImpact?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenCoustomCertificateForimpact(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root> 
      
      
       {/* Generate delegate Certificate For Impact  */}
       <Transition.Root show={onGenCoustomCertificateForimpactForDelegate} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnGenCoustomCertificateForimpactForDelegate}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={CoustomCertificategenerateCertificateForDelegate.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Participantion Certificate For Impact Director
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenCoustomCertificateForimpactForDelegate(false);
                                  setIsFormSubmmitedCertificateForImpactForDelegate(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          {/* <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.type}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div> */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Title (optional)
                            </label>
                            <textarea
                              type="text"
                              name="first_line"
                              id="first_line"
                              maxlength="60"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.first_line}
                             
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          {/* <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="second_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Second Line
                            </label>
                            <textarea
                              type="text"
                              name="second_line"
                              id="second_line"
                              maxlength="50"
                              onChange={CoustomCertificategenerateCertificate.handleChange}
                              value={CoustomCertificategenerateCertificate.values.second_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div> */}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              autoComplete="false"
                              name="country"
                              readOnly="true"
                              id="country"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={CoustomCertificategenerateCertificateForDelegate.handleChange}
                              value={CoustomCertificategenerateCertificateForDelegate.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedCertificateForImpactForDelegate && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <ParticipantionCertificateForImpact
                                    FirstName={coustomcertificateFormDataImpactForDelegate.first_name}
                                    LastName={coustomcertificateFormDataImpactForDelegate.last_name}
                                    first_line={coustomcertificateFormDataImpactForDelegate.first_line}
                                    second_line={coustomcertificateFormDataImpactForDelegate.second_line}
                                    end_date={coustomcertificateFormDataImpactForDelegate.end_date}
                                    country={coustomcertificateFormDataImpactForDelegate.country}
                                    eventid={coustomcertificateFormDataImpactForDelegate?.event_id}
                                    qrText={coustomcertificateFormDataImpactForDelegate.qr_text}
                                    type={coustomcertificateFormDataImpactForDelegate.type.toUpperCase()}
                                    
                                  />
                                }
                                fileName={`Certificate-${coustomcertificateFormDataImpactForDelegate?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenCoustomCertificateForimpactForDelegate(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

    {/* Generate Certificate */}
      <Transition.Root show={onGenCertificate} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={setOnGenCertificate}
        >
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={generateCertificate.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg font-medium text-white">
                                Custom Certificate
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnGenCertificate(false);
                                  setIsFormSubmmited(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="text-lg font-semibold">
                              Fields Required to Generate Certificate
                            </span>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First name
                            </label>
                            <input
                              type="text"
                              name="first_name"
                              id="first_name"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.first_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="last_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Last name
                            </label>
                            <input
                              type="text"
                              name="last_name"
                              id="last_name"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.last_name}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="type"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Certificate Type
                            </label>
                            <input
                              type="text"
                              name="type"
                              id="type"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.type}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="first_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              First Line
                            </label>
                            <textarea
                              type="text"
                              name="first_line"
                              id="first_line"
                              maxlength="150"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.first_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="second_line"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Second Line
                            </label>
                            <textarea
                              type="text"
                              name="second_line"
                              id="second_line"
                              maxlength="50"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.second_line}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="end_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              End Date
                            </label>
                            <input
                              type="date"
                              name="end_date"
                              id="end_date"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.end_date}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Country
                            </label>
                            <input
                              type="text"
                              name="country"
                              id="country"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.country}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="qr_text"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              QR Text
                            </label>
                            <textarea
                              type="text"
                              name="qr_text"
                              id="qr_text"
                              onChange={generateCertificate.handleChange}
                              value={generateCertificate.values.qr_text}
                              required
                              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          {isFormSubmmitedCertificate && (
                            <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                              <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                                Certificate
                              </span>
                              <PDFDownloadLink
                                document={
                                  <CustomCertificate
                                    FirstName={certificateFormData.first_name}
                                    LastName={certificateFormData.last_name}
                                    first_line={certificateFormData.first_line}
                                    second_line={
                                      certificateFormData.second_line
                                    }
                                    end_date={certificateFormData.end_date}
                                    country={certificateFormData.country}
                                    qrText={certificateFormData.qr_text}
                                    type={certificateFormData.type.toUpperCase()}
                                  />
                                }
                                fileName={`Certificate-${certificateFormData?.first_name}.pdf`}
                              >
                                {" "}
                                <span className="group relative flex w-64 justify-center rounded-md border border-transparent bg-blue-400 my-4  py-2 px-4 text-sm font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                                  {" "}
                                  Download PDF
                                </span>
                              </PDFDownloadLink>
                            </div>
                          )}
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <span className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">
                              Note
                            </span>
                            <span className="mt-1 block w-full rounded-md text-red-500 sm:text-sm">
                              Press Generate before download
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnGenCertificate(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Generate
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* invite */}

      <Transition.Root show={onSendInvite} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOnSendInvite}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <form
                      className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl"
                      onSubmit={sendInviteForm.handleSubmit}
                    >
                      <div className="flex-1">
                        {/* Header */}
                        <div className="banner-back px-4 py-6 sm:px-6">
                          <div className="flex items-start justify-between space-x-3">
                            <div className="space-y-1">
                              <Dialog.Title className="text-lg flex gap-2 font-medium text-white">
                                <span>Send Invitation</span>{" "}
                                <PaperAirplaneIcon className="h-6 w-6" />
                              </Dialog.Title>
                              {/* <p className="text-sm text-gray-500">
                                Get started..
                              </p> */}
                            </div>
                            <div className="flex h-7 items-center">
                              <button
                                type="button"
                                className="text-white hover:text-white"
                                onClick={() => {
                                  setOnSendInvite(false);
                                }}
                              >
                                <span className="sr-only">Close panel</span>
                                <XMarkIcon
                                  className="h-6 w-6"
                                  aria-hidden="true"
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Divider container */}
                        <div className="space-y-6 py-6 sm:space-y-0 sm:divide-y sm:divide-gray-200 sm:py-0">
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="email"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Email <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="email"
                              id="email"
                              required
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.email}
                              className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="delegate_name"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Delegate Name{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="text"
                              name="delegate_name"
                              id="delegate_name"
                              required
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.delegate_name}
                              className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            />
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="payment_package"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Payment Package{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              type="text"
                              name="payment_package"
                              id="payment_package"
                              required
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.payment_package}
                              className="mt-1 block w-72 rounded-md border-gray-300 sh  eventinvitationadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>

                              <option value="Accommodation">
                                Accommodation
                              </option>
                              <option value="Accommodation (First Payment Pending)">
                                Accommodation (First Payment Pending)
                              </option>
                              <option value="Accommodation (Second Payment Pending)">
                                Accommodation (Second Payment Pending)
                              </option>
                              <option value="Non-Accommodation">
                                Non-Accommodation
                              </option>
                              <option value="Non-Accommodation (First Payment Pending)">
                                Non-Accommodation (First Payment Pending)
                              </option>
                              <option value="Non-Accommodation (Second Payment Pending)">
                                Non-Accommodation (Second Payment Pending)
                              </option>
                              <option value="Pay on Arrival">
                                Pay on Arrival
                              </option>
                              <option value="Full Experience">
                                Full Experience
                              </option>
                              <option value="Full Experience (Second Payment Pending)">
                                Full Experience (Second Payment Pending)
                              </option>
                            </select>
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="payment_package"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Package{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              type="text"
                              name="package"
                              id="package"
                              required
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.package}
                              className="mt-1 block w-72 rounded-md border-gray-300 sh  eventinvitationadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>
                              <option value="Accommodation">
                                Accommodation
                              </option>
                              <option value="Non-Accommodation">
                                Non-Accommodation
                              </option>
                            </select>
                          </div>

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="payment_mode"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Payment Mode{" "}
                              <span className="text-red-500">*</span>
                            </label>
                            <select
                              type="text"
                              name="payment_mode"
                              id="payment_mode"
                              required
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.payment_mode}
                              className="mt-1 block w-72 rounded-md border-gray-300 sh  eventinvitationadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>

                              <option value="Credit Card">
                                Credit/Debit Card
                              </option>
                              <option value="Bank Transfer">
                                Bank Transfer
                              </option>
                            </select>
                          </div>
                          {["Accommodation", "Non-Accommodation"].includes(
                            sendInviteForm.values.payment_package
                          ) && (
                              <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                <label
                                  htmlFor="order_number"
                                  className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                >
                                  Order Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                  type="text"
                                  name="order_number"
                                  id="order_number"
                                  required
                                  onChange={sendInviteForm.handleChange}
                                  value={sendInviteForm.values.order_number}
                                  className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                />
                              </div>
                            )}

                          {[
                            "Accommodation (First Payment Pending)",
                            "Non-Accommodation (First Payment Pending)",
                            "Accommodation (Second Payment Pending)",
                            "Non-Accommodation (Second Payment Pending)",
                            "Full Experience",
                            "Full Experience (Second Payment Pending)",
                            "Pay on Arrival",
                            ""
                          ].includes(sendInviteForm.values.payment_package) && (
                              <>
                                <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                  <label
                                    htmlFor="order_first_installment"
                                    className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                  >
                                    Order Number First Installment <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    name="order_first_installment"
                                    id="order_first_installment"
                                    required
                                    onChange={sendInviteForm.handleChange}
                                    value={sendInviteForm.values.order_first_installment}
                                    className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                  />
                                </div>

                                <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                                  <label
                                    htmlFor="order_second_installment"
                                    className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                                  >
                                    Order Number Second Installment
                                  </label>
                                  <input
                                    type="text"
                                    name="order_second_installment"
                                    id="order_second_installment"
                                    onChange={sendInviteForm.handleChange}
                                    value={sendInviteForm.values.order_second_installment}
                                    className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                                  />
                                </div>
                              </>
                            )}

                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="payment_date"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Payment Date <span className="text-red-500">*</span>
                            </label>
                          <input
                            type="date"
                            name="payment_date"
                            id="payment_date"
                            required
                            onChange={sendInviteForm.handleChange}
                            value={sendInviteForm.values.payment_date}
                            className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                          />
                        </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="invoice"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Invoice {sendInviteForm.values.payment_mode == 'Bank Transfer' ? <span className="text-red-500">*</span> : <p className=" font-thin italic">(optional)</p>}
                            </label>

                            <div className="sm:col-span-2 flex items-center">
                              <input
                                type="file"
                                name="invoice"
                                id="invoice"
                                onChange={(e) => uploadDocument(e, 'invoice')}
                                className="sr-only"
                              />
                              
                              <label
                                htmlFor="invoice"
                                className="cursor-pointer flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              >
                                Choose File
                              </label>

                              <span className="text-sm text-gray-500 truncate max-w-[200px]">
                                {sendInviteForm.values.invoice?.message?.file_name || "No file chosen"}
                              </span>

                              {sendInviteForm.values.invoice && (
                                <button
                                  type="button"
                                  onClick={() => sendInviteForm.setFieldValue("invoice", null)}
                                  className="text-sm text-red-500 hover:underline focus:outline-none"
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="bank_receipt"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Bank Receipt {sendInviteForm.values.payment_mode == 'Bank Transfer' ? <span className="text-red-500">*</span> : <p className=" font-thin italic">(optional)</p>}
                            </label>

                            <div className="sm:col-span-2 flex items-center">
                              <input
                              type="file"
                              name="bank_receipt"
                              id="bank_receipt"
                              onChange={(e) => uploadDocument(e, 'bank_receipt')}
                              className="sr-only"
                              />
                              
                              <label
                                htmlFor="bank_receipt"
                                className="cursor-pointer flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
                              >
                                Choose File
                              </label>

                              <span className="text-sm text-gray-500 truncate max-w-[200px]">
                                {sendInviteForm.values.bank_receipt?.message?.file_name || "No file chosen"}
                              </span>

                              {sendInviteForm.values.bank_receipt && (
                                <button
                                  type="button"
                                  onClick={() => sendInviteForm.setFieldValue("bank_receipt", null)}
                                  className="text-sm text-red-500 hover:underline focus:outline-none"
                                >
                                  Clear
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="representing_country"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Representing Country
                              <p className=" font-thin italic">(optional)</p>
                            </label>
                            <select
                              type="text"
                              name="representing_country"
                              id="representing_country"
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.representing_country}
                              className="mt-1 block w-72 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            >
                              <option value="">Select</option>
                              <option value="Afghanistan">Afghanistan</option>
                              <option value="Antigua and Barbuda">
                                Antigua and Barbuda
                              </option>

                              <option value="Aruba">Aruba</option>
                              <option value="Albania">Albania</option>
                              <option value="Algeria">Algeria</option>
                              <option value="Andorra">Andorra</option>
                              <option value="Angola">Angola</option>
                              <option value="Argentina">Argentina</option>
                              <option value="Armenia">Armenia</option>
                              <option value="Australia">Australia</option>
                              <option value="Austria">Austria</option>
                              <option value="Azerbaijan">Azerbaijan</option>
                              <option value="Bahamas">Bahamas</option>
                              <option value="Bahrain">Bahrain</option>
                              <option value="Bangladesh">Bangladesh</option>
                              <option value="Barbados">Barbados</option>
                              <option value="Belarus">Belarus</option>
                              <option value="Belgium">Belgium</option>
                              <option value="Belize">Belize</option>
                              <option value="Benin">Benin</option>
                              <option value="Bhutan">Bhutan</option>
                              <option value="Bolivia">Bolivia</option>
                              <option value="Bosnia and Herzegovina">
                                Bosnia and Herzegovina
                              </option>
                              <option value="Botswana">Botswana</option>
                              <option value="Brazil">Brazil</option>
                              <option value="Brunei">Brunei</option>
                              <option value="Bulgaria">Bulgaria</option>
                              <option value="Burkina Faso">Burkina Faso</option>
                              <option value="Burundi">Burundi</option>
                              <option value="Cambodia">Cambodia</option>
                              <option value="Cameroon">Cameroon</option>
                              <option value="Canada">Canada</option>
                              <option value="Cape Verde">Cape Verde</option>
                              <option value="Central African Republic">
                                Central African Republic
                              </option>
                              <option value="Chad">Chad</option>
                              <option value="Chile">Chile</option>
                              <option value="China">China</option>
                              <option value="Colombia">Colombia</option>
                              <option value="Comoros">Comoros</option>
                              <option value="Congo, The Democratic Republic of The">
                                Congo, The Democratic Republic of The
                              </option>
                              <option value="Republic of the Congo">
                                Republic of the Congo
                              </option>
                              <option value="Costa Rica">Costa Rica</option>
                              <option value="Côte d'Ivoire">
                                Côte d'Ivoire
                              </option>
                              <option value="Croatia">Croatia</option>
                              <option value="Cuba">Cuba</option>
                              <option value="Cyprus">Cyprus</option>
                              <option value="Czech Republic">
                                Czech Republic
                              </option>
                              <option value="Denmark">Denmark</option>
                              <option value="Djibouti">Djibouti</option>
                              <option value="Dominica">Dominica</option>
                              <option value="Dominican Republic">
                                Dominican Republic
                              </option>
                              <option value="Ecuador">Ecuador</option>
                              <option value="Eswatini">Eswatini</option>
                              <option value="Egypt">Egypt</option>
                              <option value="El Salvador">El Salvador</option>
                              <option value="Equatorial Guinea">
                                Equatorial Guinea
                              </option>
                              <option value="Eritrea">Eritrea</option>
                              <option value="Estonia">Estonia</option>
                              <option value="Ethiopia">Ethiopia</option>
                              <option value="Fiji">Fiji</option>
                              <option value="Finland">Finland</option>
                              <option value="France">France</option>
                              <option value="Gabon">Gabon</option>
                              <option value="Gambia">Gambia</option>
                              <option value="Georgia">Georgia</option>
                              <option value="Germany">Germany</option>
                              <option value="Ghana">Ghana</option>
                              <option value="Greece">Greece</option>
                              <option value="Grenada">Grenada</option>
                              <option value="Guatemala">Guatemala</option>
                              <option value="Guinea">Guinea</option>
                              <option value="Guinea-bissau">
                                Guinea-bissau
                              </option>
                              <option value="Guyana">Guyana</option>
                              <option value="Haiti">Haiti</option>
                              <option value="Holy See (Vatican City State)">
                                Holy See (Vatican City State)
                              </option>
                              <option value="Honduras">Honduras</option>
                              <option value="Hungary">Hungary</option>
                              <option value="Iceland">Iceland</option>
                              <option value="India">India</option>
                              <option value="Indonesia">Indonesia</option>
                              <option value="Iran">Iran</option>
                              <option value="Iraq">Iraq</option>
                              <option value="Ireland">Ireland</option>
                              <option value="Israel">Israel</option>
                              <option value="Italy">Italy</option>
                              <option value="Jamaica">Jamaica</option>
                              <option value="Japan">Japan</option>
                              <option value="Jordan">Jordan</option>
                              <option value="Kazakhstan">Kazakhstan</option>
                              <option value="Kenya">Kenya</option>
                              <option value="North Korea">North Korea</option>
                              <option value="South Korea">South Korea</option>
                              <option value="Kuwait">Kuwait</option>
                              <option value="Kosovo">Kosovo</option>
                              <option value="Lao People's Democratic Republic">
                                Lao People's Democratic Republic
                              </option>
                              <option value="Kyrgyzstan">Kyrgyzstan</option>
                              <option value="Kiribati">Kiribati</option>
                              <option value="Latvia">Latvia</option>
                              <option value="Lebanon">Lebanon</option>
                              <option value="Lesotho">Lesotho</option>
                              <option value="Liberia">Liberia</option>
                              <option value="Liechtenstein">
                                Liechtenstein
                              </option>
                              <option value="Lithuania">Lithuania</option>
                              <option value="Luxembourg">Luxembourg</option>

                              <option value="Madagascar">Madagascar</option>
                              <option value="Malawi">Malawi</option>
                              <option value="Malaysia">Malaysia</option>
                              <option value="Maldives">Maldives</option>
                              <option value="Mali">Mali</option>
                              <option value="Malta">Malta</option>
                              <option value="Marshall Islands">
                                Marshall Islands
                              </option>
                              <option value="Mauritania">Mauritania</option>
                              <option value="Mauritius">Mauritius</option>
                              <option value="Mexico">Mexico</option>
                              <option value="Micronesia, Federated States of">
                                Micronesia, Federated States of
                              </option>
                              <option value="Moldova, Republic of">
                                Moldova, Republic of
                              </option>
                              <option value="Monaco">Monaco</option>
                              <option value="Mongolia">Mongolia</option>
                              <option value="Montenegro">Montenegro</option>
                              <option value="Macedonia, The Former Yugoslav Republic of">
                                Macedonia, The Former Yugoslav Republic of
                              </option>
                              <option value="Morocco">Morocco</option>
                              <option value="Mozambique">Mozambique</option>
                              <option value="Myanmar">Myanmar</option>
                              <option value="Namibia">Namibia</option>
                              <option value="Nauru">Nauru</option>
                              <option value="Nepal">Nepal</option>
                              <option value="Netherlands">Netherlands</option>
                              <option value="New Zealand">New Zealand</option>
                              <option value="Nicaragua">Nicaragua</option>
                              <option value="Niger">Niger</option>
                              <option value="Nigeria">Nigeria</option>
                              <option value="Norway">Norway</option>
                              <option value="North Macedonia">
                                North Macedonia
                              </option>
                              <option value="Oman">Oman</option>
                              <option value="Pakistan">Pakistan</option>
                              <option value="Palestinian Territories">
                                Palestinian Territories
                              </option>
                              <option value="Palau">Palau</option>

                              <option value="Panama">Panama</option>
                              <option value="Papua New Guinea">
                                Papua New Guinea
                              </option>
                              <option value="Paraguay">Paraguay</option>
                              <option value="Peru">Peru</option>
                              <option value="Philippines">Philippines</option>
                              <option value="Poland">Poland</option>
                              <option value="Portugal">Portugal</option>
                              <option value="Qatar">Qatar</option>
                              <option value="Romania">Romania</option>
                              <option value="Russia">Russia</option>
                              <option value="Rwanda">Rwanda</option>
                              <option value="Saint Kitts and Nevis">
                                Saint Kitts and Nevis
                              </option>
                              <option value="Saint Lucia">Saint Lucia</option>
                              <option value="Saint Vincent and the Grenadines">
                                Saint Vincent and the Grenadines
                              </option>
                              <option value="Samoa">Samoa</option>
                              <option value="State of Libya">
                                State of Libya
                              </option>
                              <option value="Swaziland">Swaziland</option>
                              <option value="San Marino">San Marino</option>
                              <option value="Sao Tome and Principe">
                                Sao Tome and Principe
                              </option>
                              <option value="Saudi Arabia">Saudi Arabia</option>
                              <option value="Senegal">Senegal</option>
                              <option value="Serbia">Serbia</option>
                              <option value="Seychelles">Seychelles</option>
                              <option value="Sierra Leone">Sierra Leone</option>

                              <option value="Singapore">Singapore</option>
                              <option value="Slovakia">Slovakia</option>
                              <option value="Slovenia">Slovenia</option>
                              <option value="Solomon Islands">
                                Solomon Islands
                              </option>
                              <option value="Somalia">Somalia</option>
                              <option value="South Africa">South Africa</option>
                              <option value="Spain">Spain</option>
                              <option value="Sri Lanka">Sri Lanka</option>
                              <option value="Sudan">Sudan</option>
                              <option value="South Sudan">South Sudan</option>
                              <option value="Suriname">Suriname</option>
                              <option value="Sweden">Sweden</option>
                              <option value="Switzerland">Switzerland</option>
                              <option value="Syrian Arab Republic">
                                Syrian Arab Republic
                              </option>
                              <option value="Tajikistan">Tajikistan</option>
                              <option value="Tuvalu">Tuvalu</option>
                              <option value="Tanzania">Tanzania</option>
                              <option value="Thailand">Thailand</option>
                              <option value="Timor-leste">Timor-leste</option>
                              <option value="Togo">Togo</option>
                              <option value="Tonga">Tonga</option>
                              <option value="Trinidad and Tobago">
                                Trinidad and Tobago
                              </option>
                              <option value="Tunisia">Tunisia</option>
                              <option value="Turkey">Turkey</option>
                              <option value="Turkmenistan">Turkmenistan</option>
                              <option value="Uganda">Uganda</option>
                              <option value="Ukraine">Ukraine</option>
                              <option value="United Arab Emirates">
                                United Arab Emirates
                              </option>
                              <option value="United Kingdom">
                                United Kingdom
                              </option>
                              <option value="United States">
                                United States
                              </option>
                              <option value="Uruguay">Uruguay</option>
                              <option value="Uzbekistan">Uzbekistan</option>
                              <option value="Vanuatu">Vanuatu</option>
                              <option value="Venezuela">Venezuela</option>
                              <option value="Viet Nam">Viet Nam</option>
                              <option value="Yemen">Yemen</option>
                              <option value="Zambia">Zambia</option>
                              <option value="Zimbabwe">Zimbabwe</option>
                              <option value="International Observer">
                                International Observer
                              </option>
                              <option value="Ambassador">Ambassador</option>
                              <option value="Diplomatic Experts">
                                Diplomatic Experts
                              </option>
                              <option value="Local Team Members">
                                Local Team Members
                              </option>
                              <option value="Ambassadors">Ambassadors</option>
                              <option value="Speakers and Guest of Honours">
                                Speakers and Guest of Honours
                              </option>
                              <option value="International Observers">
                                International Observers
                              </option>
                              <option value="Volunteers">Volunteers</option>
                              <option value="Johnson and Johnson">
                                Johnson and Johnson
                              </option>
                              <option value="JP Morgan">JP Morgan</option>
                              <option value="HSBC">HSBC</option>
                              <option value="Verizon">Verizon</option>
                              <option value="BRAC">BRAC</option>
                              <option value="International Committee of the Red Cross (ICRC)">
                                International Committee of the Red Cross (ICRC)
                              </option>
                              <option value="Nestle">Nestle</option>
                              <option value="Human Rights Watch">
                                Human Rights Watch
                              </option>
                              <option value="UnitedHealth Group">
                                UnitedHealth Group
                              </option>
                            </select>
                          </div>
                          <div className="space-y-1 px-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-5">
                            <label
                              htmlFor="event"
                              className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2"
                            >
                              Event
                            </label>
                            <input
                              type="text"
                              name="event"
                              id="event"
                              disabled
                              onChange={sendInviteForm.handleChange}
                              value={sendInviteForm.values.event}
                              className="mt-1 block w-72 rounded-md text-gray-500 border-gray-200 shadow-sm focus:border-gray-500 focus:ring-gray-500 sm:text-sm"
                            />
                            {}
                          </div>
                        </div>
                      </div>

                      {/* Action buttons */}
                      <div className="flex-shrink-0 border-t border-gray-200 px-4 py-5 sm:px-6">
                        <div className="flex justify-end space-x-3">
                          <button
                            type="button"
                            className="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                            onClick={() => setOnSendInvite(false)}
                          >
                            Cancel
                          </button>

                          <button
                            type="submit"
                            disabled={sendInviteForm.values.payment_mode == 'Bank Transfer' 
                              && ((sendInviteForm.values.invoice == null
                              || sendInviteForm.values.invoice == ''
                              || sendInviteForm.values.invoice == undefined)
                              || (sendInviteForm.values.bank_receipt == null
                                || sendInviteForm.values.bank_receipt == ''
                                || sendInviteForm.values.bank_receipt == undefined))
                            }
                            className="inline-flex color justify-center rounded-md border border-transparent bg-blue-500 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                          >
                            Send Invitation
                          </button>
                        </div>
                      </div>
                    </form>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default OperationsDashboard;
